<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent11"><a id="page_xi"></a><strong>TRILLIN ON TEXAS</strong><a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292733787_07_fm1.vue?24beffa7